import { DesignSystemColors } from '@configurations/design-system/design-system-colors.enum';
import { ChartShape } from '@scenario/enums/chart/chart-shape.enum';
import { ChartLineType } from '@scenario/enums/chart/chart-line-type.enum';

type Customization = {
  [key: string]: { color?: string, shape?: string, line?: number[], thickness?: number }
}

export const defaultReferentialValues = {
  color: 'gray',
  shape: ChartShape.DOT,
  line: ChartLineType.SOLID,
  thickness: 1
};

export const chartReferential: Customization  = {
  'BE': {
    color: DesignSystemColors.ORANGE_794
  },
  'DE': {
    color: DesignSystemColors.RED_306,
  },
  'DK2': {
    color: DesignSystemColors.RED_142,
    shape: ChartShape.DIAMOND,
  },
  'DK1': {
    color: DesignSystemColors.RED_051,
    shape: 'crossRot',
  },
  'ES': {
    color: DesignSystemColors.YELLOW_051,
  },
  'FR': {
    color: DesignSystemColors.BLUE_306,
  },
  'GB': {
    color: DesignSystemColors.BLUE_051,
  },
  'ITCA': {
    color: DesignSystemColors.GREEN_051,
    shape: ChartShape.DIAMOND
  },
  'ITCN': {
    color: DesignSystemColors.GREEN_306,
    shape: ChartShape.SQUARE
  },
  'ITCS': {
    color: DesignSystemColors.GREEN_142,
    shape: ChartShape.ROUND
  },
  'ITN': {
    color: DesignSystemColors.GREEN_470,
    shape: ChartShape.MULTIPLY
  },
  'ITS': {
    color: DesignSystemColors.GREEN_088,
    shape: ChartShape.STAR
  },
  'ITSAR': {
    color: DesignSystemColors.GREEN_027,
    shape: ChartShape.TRIANGLE
  },
  'ITSIC': {
    color: DesignSystemColors.GREEN_008,
    shape: ChartShape.PLUS
  },
  'NL': {
    color: DesignSystemColors.ORANGE_088,
  },
  'PL': {
    color: DesignSystemColors.TEAL_142,
  },
  'PT': {
    color: DesignSystemColors.PURPLE_142,
  },
  'CH': {
    color: DesignSystemColors.YELLOW_142,
  },
  'AL': {
    color: DesignSystemColors.PINK_051,
  },
  'BG': {
    color: DesignSystemColors.PURPLE_051,
  },
  'GR': {
    color: DesignSystemColors.BLUE_142,
  },
  'IE-SEM': {
    color: DesignSystemColors.GREEN_142,
  },
  'RO': {
    color: DesignSystemColors.TEAL_051,
  },
  'NIE': {
    color: DesignSystemColors.TEAL_306,
  },
  'AT': {
    color: DesignSystemColors.RED_201,
  },
  'CZ': {
    color: DesignSystemColors.ORANGE_051,
  },
  'ERCOT-Houston': {
    color: DesignSystemColors.ORANGE_142,
    shape: ChartShape.DIAMOND
  },
  'ERCOT-North': {
    color: DesignSystemColors.BLUE_142,
    shape: ChartShape.SQUARE
  },
  'ERCOT-South': {
    color: DesignSystemColors.YELLOW_051,
    shape: ChartShape.ROUND
  },
  'ERCOT-West': {
    color: DesignSystemColors.TEAL_142,
    shape: ChartShape.MULTIPLY
  },
  'IT': {
    color: DesignSystemColors.GREEN_650,
  },
  'MISO-Central': {
    color: DesignSystemColors.YELLOW_306,
    shape: ChartShape.DIAMOND
  },
  'MISO-North': {
    color: DesignSystemColors.YELLOW_027,
    shape: ChartShape.SQUARE
  },
  'MISO-RTO': {
    color: DesignSystemColors.YELLOW_142,
    shape: ChartShape.ROUND
  },
  'MISO-South': {
    color: DesignSystemColors.YELLOW_051,
    shape: ChartShape.MULTIPLY
  },
  'NO1': {
    color: DesignSystemColors.BLUE_142,
    shape: ChartShape.DIAMOND
  },
  'NO2': {
    color: DesignSystemColors.BLUE_306,
    shape: ChartShape.SQUARE
  },
  'NO3': {
    color: DesignSystemColors.BLUE_051,
    shape: ChartShape.ROUND
  },
  'NO4': {
    color: DesignSystemColors.BLUE_027,
    shape: ChartShape.MULTIPLY
  },
  'NO5': {
    color: DesignSystemColors.BLUE_470,
    shape: ChartShape.STAR
  },
  'PJM-AEP-Dayton': {
    color: DesignSystemColors.PINK_142,
    shape: ChartShape.DIAMOND
  },
  'PJM-MAAC': {
    color: DesignSystemColors.PINK_051,
    shape: ChartShape.SQUARE
  },
  'PJM-West': {
    color: DesignSystemColors.PINK_306,
    shape: ChartShape.ROUND
  },
  'PJM-RTO': {
    color: DesignSystemColors.PINK_470,
    shape: ChartShape.MULTIPLY
  },
  'PJM-South': {
    color: DesignSystemColors.PINK_014,
    shape: ChartShape.STAR
  },
  'SE1': {
    color: DesignSystemColors.PURPLE_142,
    shape: ChartShape.DIAMOND
  },
  'SE2': {
    color: DesignSystemColors.PURPLE_051,
    shape: ChartShape.SQUARE
  },
  'SE3': {
    color: DesignSystemColors.PURPLE_306,
    shape: ChartShape.ROUND
  },
  'SE4': {
    color: DesignSystemColors.PURPLE_470,
    shape: ChartShape.MULTIPLY
  },
  'jpn': {
    color: DesignSystemColors.RED_306,
  },
  'aus': {
    color: DesignSystemColors.TEAL_142,
    shape: ChartShape.DIAMOND
  },
  'nsw': {
    color: DesignSystemColors.TEAL_051,
    shape: ChartShape.SQUARE
  },
  'qld': {
    color: DesignSystemColors.TEAL_306,
    shape: ChartShape.ROUND
  },
  'saa': {
    color: DesignSystemColors.TEAL_014,
    shape: ChartShape.MULTIPLY
  },
  'tas': {
    color: DesignSystemColors.TEAL_088,
    shape: ChartShape.STAR
  },
  'vic': {
    color: DesignSystemColors.TEAL_470,
    shape: ChartShape.TRIANGLE
  },
  'AFRY': {
    color: DesignSystemColors.GREEN_794,
    shape: ChartShape.DIAMOND,
    line: ChartLineType.DOTTED
  },
  'AURORA': {
    color: DesignSystemColors.YELLOW_142,
    shape: ChartShape.STAR,
    line: ChartLineType.DOTTED
  },
  'PMF': {
    color: DesignSystemColors.RED_142,
    shape: ChartShape.ROUND,
    line: ChartLineType.SOLID
  },
  '3MV': {
    color: DesignSystemColors.RED_470,
    shape: ChartShape.MULTIPLY,
    line: ChartLineType.DASHED
  },
  'SP Global': {
    color: DesignSystemColors.PURPLE_051,
    shape: ChartShape.SQUARE,
    line: ChartLineType.DOTTED
  },
  'WoodMac': {
    color: DesignSystemColors.BLUE_142,
    shape: ChartShape.TRIANGLE,
    line: ChartLineType.DOTTED
  },
  'Central': {
    shape: ChartShape.ROUND,
    line: ChartLineType.SOLID,
    thickness: 1.5
  },
  'FPI Q4 2024-Energy': {
    shape: ChartShape.ROUND,
    line: ChartLineType.SOLID,
    thickness: 1.5
  },
  'FPI Q4 2024-REC': {
    shape: ChartShape.MULTIPLY,
    line: ChartLineType.SOLID,
    thickness: 1
  },
  'High': {
    shape: ChartShape.TRIANGLE,
    line: ChartLineType.DASHED,
    thickness: 0.75
  },
  'Low': {
    shape: ChartShape.SQUARE,
    line: ChartLineType.DOTTED,
    thickness: 0.75
  },
  'LTP24': {
    shape: ChartShape.ROUND,
    line: ChartLineType.SOLID,
    thickness: 1.5
  },
  'scen1commo1': {
    line: ChartLineType.MIX,
  },
  'scen1commo2': {
    line: ChartLineType.MIX,
  },
  'scen2commo2': {
    line: ChartLineType.MIX,
  },
  'Last Release': {
    shape: ChartShape.ROUND,
    line: ChartLineType.SOLID,
    thickness: 1.5
  },
  '2 Last Releases': {
    shape: ChartShape.TRIANGLE,
    line: ChartLineType.DASHED,
    thickness: 1.25
  },
  'Range': {
    line: ChartLineType.DOTTED,
    thickness: 1,
  },
};
